import { createApp } from "vue";
import App from "./App.vue";
import "./css/main.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";

import { WOW } from "../node_modules/wowjs/dist/wow.js";
import videojs from "./js/video.min.js";
import VideoPlayer from "vue-video-player";
import $ from "../node_modules/jquery/dist/jquery.min.js";
import "../node_modules/animate.css/animate.css";
import "./css/video-js.css";
import router from "./router";

import "../node_modules/jquery/dist/jquery.min.js";
import axios from "axios";
import VueAxios from "vue-axios";

// router.beforeEach((to, from, next) => {
//     /* 路由发生变化修改页面title */
//     if (to.meta.title) {
//         document.title = to.meta.title;
//     }

// })

axios.defaults.baseURL = "/api";
createApp(App).use(router).use(VueAxios, axios).mount("#app");

createApp(App).use(router).use(VideoPlayer);
